import {
  AdminUser,
  AdminStudent,
  PendingRegistration,
  AdminTeacher,
  AcademicLevel,
  AcademicBatch,
  MasterEntry,
  ScheduledClass,
  AttendanceSessionLog,
  SutraCatalogItem,
  GathaSubmission,
  StavanItem,
  AudioAsset,
  QuizGameItem,
  NiyamSubmission,
  NiyamRule,
  BonusEventItem,
  PointsLedgerTransaction,
  AuditLogEntry,
  BroadcastMessage,
  SystemSettings,
  DailyQuoteItem,
  GurudevProfileItem,
  SadhuSadhvijiItem,
  ViharUpdateItem,
  ChaturmasDetailItem,
  BookStoreItem,
} from './types';

export const INITIAL_ADMIN_USERS: AdminUser[] = [
  {
    id: 'USR-001',
    username: 'superadmin',
    name: 'Pujya Acharya Shri Prasad ji',
    email: 'superadmin@jainpathshala.org',
    role: 'SuperAdmin',
    avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
    status: 'Active',
    lastLogin: '2026-07-23 09:15 AM',
  },
  {
    id: 'USR-002',
    username: 'adminoffice',
    name: 'Ketanbhai Mehta',
    email: 'ketan.mehta@jainpathshala.org',
    role: 'Admin',
    avatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200',
    status: 'Active',
    lastLogin: '2026-07-22 04:30 PM',
  },
  {
    id: 'USR-003',
    username: 'gurujirajvi',
    name: 'Rajvi Ben Shah',
    email: 'rajvi.teacher@jainpathshala.org',
    role: 'Guruji',
    avatarUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=200',
    status: 'Active',
    lastLogin: '2026-07-23 08:00 AM',
  },
  {
    id: 'USR-004',
    username: 'auditor01',
    name: 'Trustee Harshadbhai',
    email: 'harshad.trustee@jainpathshala.org',
    role: 'Auditor',
    avatarUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200',
    status: 'Active',
    lastLogin: '2026-07-20 11:20 AM',
  },
];

export const INITIAL_STUDENTS: AdminStudent[] = [
  {
    id: 'STU-101',
    firstName: 'Aarav',
    surname: 'Shah',
    photoUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
    dob: '2014-05-12',
    gender: 'Male',
    mobile: '+91 98201 12345',
    parentMobile: '+91 98201 99999',
    email: 'parent.aarav@gmail.com',
    address: '402, Shanti Heights, M.G. Road, Malad West, Mumbai',
    level: 'Level 3 - Shravak Junior',
    batch: 'Batch A - Weekend Morning',
    isAttendingPathshala: true,
    attendanceRate: 94,
    totalGathas: 16,
    pointsBalance: 670,
    status: 'Active',
    registrationDate: '2025-06-10',
  },
  {
    id: 'STU-102',
    firstName: 'Dhairya',
    surname: 'Kothari',
    photoUrl: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&q=80&w=200',
    dob: '2015-08-20',
    gender: 'Male',
    mobile: '+91 98202 23456',
    parentMobile: '+91 98202 88888',
    email: 'kothari.family@gmail.com',
    address: 'B-12, Paras Nagar, Vile Parle East, Mumbai',
    level: 'Level 2 - Madhyamik',
    batch: 'Batch B - Weekend Evening',
    isAttendingPathshala: true,
    attendanceRate: 88,
    totalGathas: 12,
    pointsBalance: 520,
    status: 'Active',
    registrationDate: '2025-06-15',
  },
  {
    id: 'STU-103',
    firstName: 'Aanya',
    surname: 'Shah',
    photoUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&q=80&w=200',
    dob: '2016-02-14',
    gender: 'Female',
    mobile: '+91 98203 34567',
    parentMobile: '+91 98203 77777',
    email: 'aanya.mom@gmail.com',
    address: '101, Mahavir Krupa, Ghatkopar East, Mumbai',
    level: 'Level 1 - Prarambhik',
    batch: 'Batch A - Weekend Morning',
    isAttendingPathshala: true,
    attendanceRate: 96,
    totalGathas: 8,
    pointsBalance: 410,
    status: 'Active',
    registrationDate: '2025-07-01',
  },
  {
    id: 'STU-104',
    firstName: 'Hetvi',
    surname: 'Desai',
    photoUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200',
    dob: '2013-11-05',
    gender: 'Female',
    mobile: '+91 98204 45678',
    parentMobile: '+91 98204 66666',
    email: 'desai.hetvi@gmail.com',
    address: '504, Rishabh Tower, Borivali West, Mumbai',
    level: 'Level 3 - Shravak Junior',
    batch: 'Batch B - Weekend Evening',
    isAttendingPathshala: true,
    attendanceRate: 72,
    totalGathas: 14,
    pointsBalance: 390,
    status: 'Active',
    registrationDate: '2025-06-20',
  },
  {
    id: 'STU-105',
    firstName: 'Kavya',
    surname: 'Mehta',
    photoUrl: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&q=80&w=200',
    dob: '2017-01-22',
    gender: 'Female',
    mobile: '+91 98205 56789',
    parentMobile: '+91 98205 55555',
    email: 'mehta.kavya@gmail.com',
    address: '302, Navkar Residency, Kandivali West, Mumbai',
    level: 'Level 1 - Prarambhik',
    batch: 'Batch A - Weekend Morning',
    isAttendingPathshala: true,
    attendanceRate: 68,
    totalGathas: 4,
    pointsBalance: 210,
    status: 'Active',
    registrationDate: '2025-08-10',
  },
];

export const INITIAL_PENDING_REGISTRATIONS: PendingRegistration[] = [
  {
    id: 'REG-2026-001',
    studentName: 'Viraj Vora',
    parentName: 'Sanjay Vora',
    parentMobile: '+91 98111 22334',
    email: 'sanjay.vora@gmail.com',
    requestedLevel: 'Level 1 - Prarambhik',
    preferredBatch: 'Batch A - Weekend Morning',
    submissionDate: '2026-07-22',
    address: '701, Arihant Enclave, Walkeshwar, Mumbai',
    verificationFlags: {
      addressVerified: true,
      phoneVerified: true,
      docsVerified: true,
    },
    status: 'Pending',
    notes: 'Parent requested morning batch due to swimming coaching.',
    registrationFee: 100,
    paymentStatus: 'Paid',
    paymentDate: '2026-07-22 09:30 AM',
    paymentTxnId: 'TXN_98234120',
    paymentMethod: 'UPI',
  },
  {
    id: 'REG-2026-002',
    studentName: 'Ananya Parekh',
    parentName: 'Bhavin Parekh',
    parentMobile: '+91 98222 33445',
    email: 'bhavin.parekh@yahoo.com',
    requestedLevel: 'Level 2 - Madhyamik',
    preferredBatch: 'Batch B - Weekend Evening',
    submissionDate: '2026-07-21',
    address: '12, Neminath Apt, Dadar West, Mumbai',
    verificationFlags: {
      addressVerified: true,
      phoneVerified: true,
      docsVerified: false,
    },
    status: 'Pending',
    notes: 'Awaiting birth certificate re-upload.',
    registrationFee: 100,
    paymentStatus: 'Pending',
    paymentDate: '2026-07-21 02:15 PM',
    paymentTxnId: 'TXN_98234121',
    paymentMethod: 'QR Code',
  },
  {
    id: 'REG-2026-003',
    studentName: 'Siddharth Gandhi',
    parentName: 'Deepak Gandhi',
    parentMobile: '+91 98333 44556',
    email: 'deepak.gandhi@gmail.com',
    requestedLevel: 'Level 3 - Shravak Junior',
    preferredBatch: 'Batch A - Weekend Morning',
    submissionDate: '2026-07-20',
    address: 'A-401, Adinath Villa, Mulund West, Mumbai',
    verificationFlags: {
      addressVerified: true,
      phoneVerified: true,
      docsVerified: true,
    },
    status: 'Pending',
    registrationFee: 100,
    paymentStatus: 'Failed',
    paymentDate: '2026-07-20 05:45 PM',
    paymentTxnId: 'TXN_98234122',
    paymentMethod: 'Card',
  },
  {
    id: 'REG-2026-004',
    studentName: 'Diya Shah',
    parentName: 'Manish Shah',
    parentMobile: '+91 98444 55667',
    email: 'manish.shah@gmail.com',
    requestedLevel: 'Level 1 - Prarambhik',
    preferredBatch: 'Batch B - Weekend Evening',
    submissionDate: '2026-07-19',
    address: '303, Mahavir Tower, Ghatkopar East, Mumbai',
    verificationFlags: {
      addressVerified: true,
      phoneVerified: true,
      docsVerified: true,
    },
    status: 'Approved',
    notes: 'Verified and assigned to Batch B.',
    registrationFee: 100,
    paymentStatus: 'Paid',
    paymentDate: '2026-07-19 11:20 AM',
    paymentTxnId: 'TXN_98234123',
    paymentMethod: 'UPI',
  },
  {
    id: 'REG-2026-005',
    studentName: 'Kavish Mehta',
    parentName: 'Prashant Mehta',
    parentMobile: '+91 98555 66778',
    email: 'prashant.mehta@outlook.com',
    requestedLevel: 'Level 2 - Madhyamik',
    preferredBatch: 'Batch A - Weekend Morning',
    submissionDate: '2026-07-18',
    address: 'B-502, Paras Dham, Borivali West, Mumbai',
    verificationFlags: {
      addressVerified: false,
      phoneVerified: true,
      docsVerified: false,
    },
    status: 'Rejected',
    rejectionReason: 'Invalid address verification documents provided.',
    registrationFee: 100,
    paymentStatus: 'Failed',
    paymentDate: '2026-07-18 04:10 PM',
    paymentTxnId: 'TXN_98234124',
    paymentMethod: 'Net Banking',
  },
  {
    id: 'REG-2026-006',
    studentName: 'Riya Kothari',
    parentName: 'Hiren Kothari',
    parentMobile: '+91 98666 77889',
    email: 'hiren.kothari@gmail.com',
    requestedLevel: 'Level 1 - Prarambhik',
    preferredBatch: 'Batch A - Weekend Morning',
    submissionDate: '2026-07-23',
    address: '201, Shanti Niketan, Juhu, Mumbai',
    verificationFlags: {
      addressVerified: true,
      phoneVerified: true,
      docsVerified: true,
    },
    status: 'Pending',
    registrationFee: 100,
    paymentStatus: 'Paid',
    paymentDate: '2026-07-23 08:15 AM',
    paymentTxnId: 'TXN_98234125',
    paymentMethod: 'QR Code',
  },
];

export const INITIAL_TEACHERS: AdminTeacher[] = [
  {
    id: 'TCH-01',
    name: 'Rajvi Ben Shah',
    title: 'Senior Guruji',
    mobile: '+91 98920 11111',
    email: 'rajvi.teacher@jainpathshala.org',
    assignedLevels: ['Level 1 - Prarambhik', 'Level 3 - Shravak Junior'],
    assignedBatches: ['Batch A - Weekend Morning', 'Batch B - Weekend Evening'],
    classesConducted: 48,
    status: 'Active',
  },
  {
    id: 'TCH-02',
    name: 'Pujya Samanji Dr. Shrutpragya ji',
    title: 'Acharya Mentor',
    mobile: '+91 98920 22222',
    email: 'samanji@jainpathshala.org',
    assignedLevels: ['Level 2 - Madhyamik', 'Level 3 - Shravak Junior'],
    assignedBatches: ['Batch A - Weekend Morning'],
    classesConducted: 32,
    status: 'Active',
  },
  {
    id: 'TCH-03',
    name: 'Meenaben Sanghvi',
    title: 'Assistant Instructor',
    mobile: '+91 98920 33333',
    email: 'meena.sanghvi@jainpathshala.org',
    assignedLevels: ['Level 1 - Prarambhik'],
    assignedBatches: ['Batch B - Weekend Evening'],
    classesConducted: 18,
    status: 'Active',
  },
];

export const INITIAL_LEVELS: AcademicLevel[] = [
  {
    id: 'LVL-1',
    code: 'LEVEL-1',
    name: 'Level 1 - Prarambhik',
    description: 'Basic Navkar Mantra, Chattari Mangalam, fundamental Jain symbols & morning rituals.',
    minAge: 5,
    maxAge: 8,
    prerequisite: 'None',
    enrolledCount: 42,
    syllabus: [
      { id: 'SYL-101', levelId: 'LVL-1', chapterName: 'Navkar Mantra - Part 1: Pronunciation & Recitation', description: 'Mastering the exact Prakrit phonetics and rhythm of the supreme mantra.', learningType: 'Sutra', displayOrder: 1, status: 'Active' },
      { id: 'SYL-102', levelId: 'LVL-1', chapterName: 'Navkar Mantra - Part 2: Meaning of 9 Sacred Padas', description: 'Understanding Arihanta, Siddha, Acharya, Upadhyaya, Sadhu and 4 Mangalam padas.', learningType: 'Sutra', displayOrder: 2, status: 'Active' },
      { id: 'SYL-103', levelId: 'LVL-1', chapterName: 'Chattari Mangalam: Recitation & Four Auspicious Entities', description: 'Learning the 4 auspicious entities: Arihanta, Siddha, Sadhu, and Kevali Prannatto Dhammo.', learningType: 'Sutra', displayOrder: 3, status: 'Active' },
      { id: 'SYL-104', levelId: 'LVL-1', chapterName: 'Panchindiya Sutra: Control Over 5 Senses', description: 'Five sensory organs and practicing mindfulness against sensory attachments.', learningType: 'Sutra', displayOrder: 4, status: 'Active' },
      { id: 'SYL-105', levelId: 'LVL-1', chapterName: 'Khamasama Sutra: Vandan to Dev, Guru & Shastra', description: 'Method of bowing with 8 limbs (Ashtanga) to revered gurus.', learningType: 'Sutra', displayOrder: 5, status: 'Active' },
      { id: 'SYL-106', levelId: 'LVL-1', chapterName: 'Icchami Khamasamo: Seeking Universal Forgiveness', description: 'Forgiveness prayer offered before and after daily pathshala lessons.', learningType: 'Sutra', displayOrder: 6, status: 'Active' },
      { id: 'SYL-107', levelId: 'LVL-1', chapterName: 'Story of King Shrenik: Devotion & Transformation', description: 'Inspirational tale of King Shrenik’s devotion to Bhagwan Mahavir.', learningType: 'Story', displayOrder: 7, status: 'Active' },
      { id: 'SYL-108', levelId: 'LVL-1', chapterName: 'Story of Shalibhadra: Virtues of Charity & Non-Attachment', description: 'Lessons on generosity, purity of intention, and spiritual detachment.', learningType: 'Story', displayOrder: 8, status: 'Active' },
      { id: 'SYL-109', levelId: 'LVL-1', chapterName: '24 Tirthankara Names & Lanchhans (Symbols)', description: 'Memorizing the 24 Tirthankara names and identifying their sacred symbols.', learningType: 'Activity', displayOrder: 9, status: 'Active' },
      { id: 'SYL-110', levelId: 'LVL-1', chapterName: 'Pratham Stavan: Shri Aadinath Bhagwan Stavan', description: 'Devotional singing in praise of the first Tirthankara Rishabhdev Bhagwan.', learningType: 'Stavan', displayOrder: 10, status: 'Active' },
      { id: 'SYL-111', levelId: 'LVL-1', chapterName: 'Jain Flag & Symbolism: Colors and Meaning', description: 'Understanding Red, Yellow, White, Green, and Dark Blue stripes and Swastika.', learningType: 'Activity', displayOrder: 11, status: 'Active' },
      { id: 'SYL-112', levelId: 'LVL-1', chapterName: 'Jin Mandir Darshan Vidhi: Nissahi & Pradakshina', description: 'Step-by-step temple etiquette, 3 Nissahis, and circumambulation.', learningType: 'Activity', displayOrder: 12, status: 'Active' },
      { id: 'SYL-113', levelId: 'LVL-1', chapterName: 'Daily Morning & Evening Niyams', description: 'Establishing daily habits: Navkarshi, Karavalatand, and water filtering.', learningType: 'Activity', displayOrder: 13, status: 'Active' },
      { id: 'SYL-114', levelId: 'LVL-1', chapterName: 'Basic Ahimsa in Daily Conduct', description: 'Kindness towards small insects, plants, animals, and gentle speech.', learningType: 'Other', displayOrder: 14, status: 'Active' },
      { id: 'SYL-115', levelId: 'LVL-1', chapterName: 'Level 1 Comprehensive Oral Practice & Review', description: 'Full revision of all Level 1 sutras, stories, and practical demonstrations.', learningType: 'Other', displayOrder: 15, status: 'Active' },
    ],
  },
  {
    id: 'LVL-2',
    code: 'LEVEL-2',
    name: 'Level 2 - Madhyamik',
    description: 'Logassa, Khamasama, 24 Tirthankaras names, Jain geography basics & daily niyams.',
    minAge: 8,
    maxAge: 11,
    prerequisite: 'Level 1 - Prarambhik',
    enrolledCount: 38,
    syllabus: [
      { id: 'SYL-201', levelId: 'LVL-2', chapterName: 'Logassa Sutra: Praise of 24 Tirthankaras', description: 'Recitation of Chattukvisaim and Kevali-pannatto Dhammo.', learningType: 'Sutra', displayOrder: 1, status: 'Active' },
      { id: 'SYL-202', levelId: 'LVL-2', chapterName: 'Karemi Bhante: Taking Samayik Vow', description: 'In-depth recitation and vow pledging for 48 minutes of equanimity.', learningType: 'Sutra', displayOrder: 2, status: 'Active' },
      { id: 'SYL-203', levelId: 'LVL-2', chapterName: 'Samaiyavaiyavao: Completion of Samayik', description: 'Concluding prayers and repentance for subtle lapses during Samayik.', learningType: 'Sutra', displayOrder: 3, status: 'Active' },
      { id: 'SYL-204', levelId: 'LVL-2', chapterName: 'Annattha Sutra: Kayotsarga Guidelines', description: 'Pratima and Kayotsarga posture rules with breath control.', learningType: 'Sutra', displayOrder: 4, status: 'Active' },
      { id: 'SYL-205', levelId: 'LVL-2', chapterName: 'Abbhutthio Sutra: Respectful Salutation to Gurudev', description: 'Asking guru for permission and forgiveness for micro transgressions.', learningType: 'Sutra', displayOrder: 5, status: 'Active' },
      { id: 'SYL-206', levelId: 'LVL-2', chapterName: 'Story of Chandanbala: Pure Devotion & Compassion', description: 'The historic offering of Bakula (boiled lentils) to Mahavir Bhagwan.', learningType: 'Story', displayOrder: 6, status: 'Active' },
      { id: 'SYL-207', levelId: 'LVL-2', chapterName: 'Story of Punya Shravak: True Value of Samayik', description: 'How King Shrenik sought to purchase Punya Shravak’s 48-minute Samayik.', learningType: 'Story', displayOrder: 7, status: 'Active' },
      { id: 'SYL-208', levelId: 'LVL-2', chapterName: 'Story of Anathi Muni: Inner Strength & Renunciation', description: 'Discourse between King Shrenik and Anathi Muni on true helplessness.', learningType: 'Story', displayOrder: 8, status: 'Active' },
      { id: 'SYL-209', levelId: 'LVL-2', chapterName: '14 Svapna of Trishala Mata', description: 'Fourteen auspicious dreams preceding the birth of a Tirthankara.', learningType: 'Story', displayOrder: 9, status: 'Active' },
      { id: 'SYL-210', levelId: 'LVL-2', chapterName: 'Navtatva Basics: Jiva & Ajiva Fundamentals', description: 'Understanding living beings (Jiva) and non-living matter (Ajiva).', learningType: 'Activity', displayOrder: 10, status: 'Active' },
      { id: 'SYL-211', levelId: 'LVL-2', chapterName: 'Stavan: Shri Mahavir Swami Stavan', description: 'Singing devotional lyrics on the life and teachings of Bhagwan Mahavir.', learningType: 'Stavan', displayOrder: 11, status: 'Active' },
      { id: 'SYL-212', levelId: 'LVL-2', chapterName: 'Stavan: Shri Parshwanath Bhagwan Stavan', description: 'Chanting stavan celebrating 23rd Tirthankara Parshwanath Bhagwan.', learningType: 'Stavan', displayOrder: 12, status: 'Active' },
      { id: 'SYL-213', levelId: 'LVL-2', chapterName: 'Jain Geography: 2.5 Dvipas & Bharat Kshetra', description: 'Jambudvipa, Dhatakikhanda, Pushkarvardvipa, and Meru Parvat.', learningType: 'Activity', displayOrder: 13, status: 'Active' },
      { id: 'SYL-214', levelId: 'LVL-2', chapterName: 'Leshya Overview: 6 Types of Thought Coloration', description: 'Black, Blue, Grey, Yellow, Pink, and White mental states illustrated.', learningType: 'Activity', displayOrder: 14, status: 'Active' },
      { id: 'SYL-215', levelId: 'LVL-2', chapterName: '18 Paap Sthanak: Introduction to 18 Sinful Activities', description: 'Identifying Himsa, Jhooth, Chori, Maithun, Parigraha and avoidances.', learningType: 'Activity', displayOrder: 15, status: 'Active' },
      { id: 'SYL-216', levelId: 'LVL-2', chapterName: 'Navkarshi & Chauvihar Protocol', description: 'Health and spiritual benefits of early dinner and morning fast.', learningType: 'Activity', displayOrder: 16, status: 'Active' },
      { id: 'SYL-217', levelId: 'LVL-2', chapterName: 'Temple Rituals: Snatra Puja Concept', description: 'Significance of Janma Kalyanak celebration and abhisheka.', learningType: 'Activity', displayOrder: 17, status: 'Active' },
      { id: 'SYL-218', levelId: 'LVL-2', chapterName: 'Respecting Teachers and Elders (Gurubhakti)', description: 'Practicing humility, attendance punctuality, and service to Sangh.', learningType: 'Other', displayOrder: 18, status: 'Active' },
      { id: 'SYL-219', levelId: 'LVL-2', chapterName: 'Shravak Code of Conduct: 12 Vows Intro', description: 'Anuvratas, Gunavratas, and Shikshavratas intro for householders.', learningType: 'Other', displayOrder: 19, status: 'Active' },
      { id: 'SYL-220', levelId: 'LVL-2', chapterName: 'Level 2 Final Written & Oral Revision', description: 'Comprehensive evaluation before promotion to Level 3.', learningType: 'Other', displayOrder: 20, status: 'Active' },
    ],
  },
  {
    id: 'LVL-3',
    code: 'LEVEL-3',
    name: 'Level 3 - Shravak Junior',
    description: 'Iryavahiyam, Namutthunam, Navtatva fundamentals, Pratikraman introductory sutras.',
    minAge: 11,
    maxAge: 15,
    prerequisite: 'Level 2 - Madhyamik',
    enrolledCount: 29,
    syllabus: [
      { id: 'SYL-301', levelId: 'LVL-3', chapterName: 'Iryavahiyam Sutra: Seeking Forgiveness for Harm', description: 'Detailed recitation for atonement of unintentional harm during movement.', learningType: 'Sutra', displayOrder: 1, status: 'Active' },
      { id: 'SYL-302', levelId: 'LVL-3', chapterName: 'Namutthunam Sutra: Praise to Arihanta Bhagwan', description: 'Reciting Sakal-Loka-Nath praise with full word meanings.', learningType: 'Sutra', displayOrder: 2, status: 'Active' },
      { id: 'SYL-303', levelId: 'LVL-3', chapterName: 'Tasutthagari Sutra: Kayotsarga Recitation', description: 'Chanting Kayotsarga prayer for eradication of karma.', learningType: 'Sutra', displayOrder: 3, status: 'Active' },
      { id: 'SYL-304', levelId: 'LVL-3', chapterName: 'Sakalkushal Sutra: Auspicious Prayer', description: 'Seeking universal well-being, peace, and spiritual growth.', learningType: 'Sutra', displayOrder: 4, status: 'Active' },
      { id: 'SYL-305', levelId: 'LVL-3', chapterName: 'Jai Viyaray Sutra: Devotion & Renunciation', description: 'Plea for destruction of attachment, hatred, and cycle of rebirths.', learningType: 'Sutra', displayOrder: 5, status: 'Active' },
      { id: 'SYL-306', levelId: 'LVL-3', chapterName: 'Arihanta Chetiyanam & Jam Kichi', description: 'Bowing to all Jain temples, icons, and pilgrimage spots across universe.', learningType: 'Sutra', displayOrder: 6, status: 'Active' },
      { id: 'SYL-307', levelId: 'LVL-3', chapterName: 'Story of Meghkumar: Patient Perseverance', description: 'Story of elephant incarnation and Meghkumar Muni’s unwavering penance.', learningType: 'Story', displayOrder: 7, status: 'Active' },
      { id: 'SYL-308', levelId: 'LVL-3', chapterName: 'Story of Kamath & Parshwanath: Forgiveness', description: 'Equanimity of Lord Parshwanath towards Kamath’s attacks.', learningType: 'Story', displayOrder: 8, status: 'Active' },
      { id: 'SYL-309', levelId: 'LVL-3', chapterName: 'Story of Metarya Muni: Supreme Compassion', description: 'Muni Metarya accepting pain silently to save a bird’s life.', learningType: 'Story', displayOrder: 9, status: 'Active' },
      { id: 'SYL-310', levelId: 'LVL-3', chapterName: 'Deep Dive into Navtatva: Punya, Papa, Ashrava, Samvar', description: 'Mechanisms of influx and blockage of karmic matter.', learningType: 'Activity', displayOrder: 10, status: 'Active' },
      { id: 'SYL-311', levelId: 'LVL-3', chapterName: 'Deep Dive into Navtatva: Nirjara, Bandha, Moksha', description: 'Shedding karma through penance (Nirjara) and ultimate liberation.', learningType: 'Activity', displayOrder: 11, status: 'Active' },
      { id: 'SYL-312', levelId: 'LVL-3', chapterName: 'Bhaktamar Stotra (Verses 1 to 10)', description: 'Recitation and Sanskrit pronunciation of Acharya Manatunga’s stotra.', learningType: 'Sutra', displayOrder: 12, status: 'Active' },
      { id: 'SYL-313', levelId: 'LVL-3', chapterName: 'Stavan: Shri Neminath Bhagwan Nem-Rajul Stavan', description: 'Melodious stavan depicting Prince Neminath’s compassion for animals.', learningType: 'Stavan', displayOrder: 13, status: 'Active' },
      { id: 'SYL-314', levelId: 'LVL-3', chapterName: 'Pratikraman Vidhi & Significance', description: 'Step-by-step performance of Devasi and Raiya Pratikraman.', learningType: 'Activity', displayOrder: 14, status: 'Active' },
      { id: 'SYL-315', levelId: 'LVL-3', chapterName: '6 Avashyakas of Jainism', description: 'Samayik, Chauvisattho, Vandana, Pratikraman, Kayotsarga, Pratyakhyan.', learningType: 'Activity', displayOrder: 15, status: 'Active' },
      { id: 'SYL-316', levelId: 'LVL-3', chapterName: 'Karma Theory Fundamentals: 8 Main Karmas', description: 'Ghanaghati and Aghati karmas: Jnanavaraniya, Darshanavaraniya, etc.', learningType: 'Activity', displayOrder: 16, status: 'Active' },
      { id: 'SYL-317', levelId: 'LVL-3', chapterName: 'Dietary Discipline: Ananta-kay & Abhakshya', description: 'Root vegetables, fermented foods, and dietary purity in Jainism.', learningType: 'Activity', displayOrder: 17, status: 'Active' },
      { id: 'SYL-318', levelId: 'LVL-3', chapterName: 'Level 3 Advanced Assessment & Evaluation', description: 'Comprehensive exam for Level 3 graduation.', learningType: 'Other', displayOrder: 18, status: 'Active' },
    ],
  },
];

export const INITIAL_BATCHES: AcademicBatch[] = [
  {
    id: 'BAT-A',
    code: 'BATCH-A',
    timeSlot: 'Batch A - Weekend Morning',
    startTime: '09:00 AM',
    endTime: '10:30 AM',
    maxCapacity: 50,
    enrolledCount: 45,
    operatingDays: ['Saturday', 'Sunday'],
  },
  {
    id: 'BAT-B',
    code: 'BATCH-B',
    timeSlot: 'Batch B - Weekend Evening',
    startTime: '05:30 PM',
    endTime: '07:00 PM',
    maxCapacity: 50,
    enrolledCount: 38,
    operatingDays: ['Saturday', 'Sunday'],
  },
];

export const INITIAL_MASTERS: MasterEntry[] = [
  { id: 'MST-1', category: 'Cities', value: 'Mumbai', status: 'Active' },
  { id: 'MST-2', category: 'Cities', value: 'Ahmedabad', status: 'Active' },
  { id: 'MST-3', category: 'Cities', value: 'Surat', status: 'Active' },
  { id: 'MST-4', category: 'Sangh', value: 'Malad Jain Sangh', status: 'Active' },
  { id: 'MST-5', category: 'Sangh', value: 'Ghatkopar Jain Shwetambar Sangh', status: 'Active' },
  { id: 'MST-6', category: 'Relationships', value: 'Father', status: 'Active' },
  { id: 'MST-7', category: 'Relationships', value: 'Mother', status: 'Active' },
  { id: 'MST-8', category: 'Documents', value: 'Birth Certificate', status: 'Active' },
  { id: 'MST-9', category: 'Documents', value: 'Aadhaar Card', status: 'Active' },
];

export const INITIAL_SCHEDULED_CLASSES: ScheduledClass[] = [
  {
    id: 'CLS-501',
    title: 'Sutra Navtatva Chapter 3',
    level: 'Level 3 - Shravak Junior',
    batch: 'Batch B - Weekend Evening',
    teacherId: 'TCH-02',
    teacherName: 'Pujya Samanji Dr. Shrutpragya ji',
    classType: 'Regular',
    dateTime: '2026-07-23 05:30 PM',
    durationMinutes: 60,
    meetingLink: 'https://zoom.us/j/98234123412',
    status: 'LIVE NOW',
    registeredCount: 28,
  },
  {
    id: 'CLS-502',
    title: 'Navkar Mantra Chanting & Meaning',
    level: 'Level 1 - Prarambhik',
    batch: 'Batch A - Weekend Morning',
    teacherId: 'TCH-01',
    teacherName: 'Rajvi Ben Shah',
    classType: 'Regular',
    dateTime: '2026-07-25 09:00 AM',
    durationMinutes: 60,
    meetingLink: 'https://zoom.us/j/98234123413',
    status: 'Scheduled',
    registeredCount: 40,
  },
  {
    id: 'CLS-503',
    title: 'Paryushan Readiness General Assembly',
    level: 'All Levels',
    batch: 'Batch A & B Combined',
    teacherId: 'TCH-02',
    teacherName: 'Pujya Samanji Dr. Shrutpragya ji',
    classType: 'General',
    dateTime: '2026-07-26 10:00 AM',
    durationMinutes: 90,
    meetingLink: 'https://zoom.us/j/98234123414',
    status: 'Scheduled',
    registeredCount: 95,
  },
];

export const INITIAL_ATTENDANCE_LOGS: AttendanceSessionLog[] = [
  {
    id: 'ATT-2026-01',
    sessionDate: '2026-07-19',
    level: 'Level 3 - Shravak Junior',
    batch: 'Batch A - Weekend Morning',
    classId: 'CLS-490',
    totalEnrolled: 29,
    presentCount: 26,
    absentCount: 3,
    attendanceRate: 89.6,
    status: 'Completed',
    records: [
      { studentId: 'STU-101', studentName: 'Aarav Shah', status: 'Present' },
      { studentId: 'STU-104', studentName: 'Hetvi Desai', status: 'Absent', notes: 'Fever reported by parent' },
    ],
  },
  {
    id: 'ATT-2026-02',
    sessionDate: '2026-07-18',
    level: 'Level 2 - Madhyamik',
    batch: 'Batch B - Weekend Evening',
    classId: 'CLS-489',
    totalEnrolled: 38,
    presentCount: 34,
    absentCount: 4,
    attendanceRate: 89.4,
    status: 'Completed',
    records: [
      { studentId: 'STU-102', studentName: 'Dhairya Kothari', status: 'Present' },
    ],
  },
];

export const INITIAL_SUTRAS_CATALOG: SutraCatalogItem[] = [
  {
    id: 'SUT-1',
    name: 'Navkar Mantra',
    targetLevel: 1,
    prakrit: ['Namo Arihantanam', 'Namo Siddhanam', 'Namo Ayariyanam', 'Namo Uvajjayanam', 'Namo Loe Savva Sahunam'],
    languages: ['Prakrit', 'English', 'Hindi', 'Gujarati'],
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
    pdfLyrics: true,
  },
  {
    id: 'SUT-2',
    name: 'Chattari Mangalam',
    targetLevel: 1,
    prakrit: ['Chattari Mangalam: Arihanta Mangalam, Siddha Mangalam...', 'Chattari Loguttama...', 'Chattari Saranam Pavvajjami...'],
    languages: ['Prakrit', 'English', 'Hindi', 'Gujarati'],
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
    pdfLyrics: true,
  },
  {
    id: 'SUT-3',
    name: 'Khamasama Sutra',
    targetLevel: 2,
    prakrit: ['Ichchhami Khamasamano, Vandium Javanijjae, Nasihae...'],
    languages: ['Prakrit', 'English', 'Hindi', 'Gujarati'],
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
    pdfLyrics: true,
  },
  {
    id: 'SUT-4',
    name: 'Logassa Sutra',
    targetLevel: 2,
    prakrit: ['Logassa Ujjoegare, Dhamma-Tithayare Jine...'],
    languages: ['Prakrit', 'English', 'Hindi', 'Gujarati'],
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3',
    pdfLyrics: true,
  },
  {
    id: 'SUT-5',
    name: 'Iryavahiyam Sutra',
    targetLevel: 3,
    prakrit: ['Ichchha-karena Sandisah Bhagavan, Iriya-vahiyam Padi-kkamami?...'],
    languages: ['Prakrit', 'English', 'Hindi', 'Gujarati'],
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3',
    pdfLyrics: true,
  },
];

export const INITIAL_GATHA_SUBMISSIONS: GathaSubmission[] = [
  {
    id: 'GAT-SUB-101',
    studentId: 'STU-102',
    studentName: 'Dhairya Kothari',
    sutraId: 'SUT-1',
    sutraName: 'Navkar Mantra',
    gathaCount: 1,
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
    submittedDate: '2026-07-22 04:15 PM',
    status: 'Pending',
    pointsAwarded: 20,
    reviewerNotes: 'Audio clear, waiting for Guruji final stamp.',
  },
  {
    id: 'GAT-SUB-102',
    studentId: 'STU-101',
    studentName: 'Aarav Shah',
    sutraId: 'SUT-5',
    sutraName: 'Iryavahiyam Sutra',
    gathaCount: 4,
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
    submittedDate: '2026-07-21 11:30 AM',
    status: 'Approved',
    pointsAwarded: 50,
    reviewerNotes: 'Flawless pronunciation of Hariya-kamane section. Approved!',
  },
  {
    id: 'GAT-SUB-103',
    studentId: 'STU-104',
    studentName: 'Hetvi Desai',
    sutraId: 'SUT-4',
    sutraName: 'Logassa Sutra',
    gathaCount: 3,
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
    submittedDate: '2026-07-20 06:45 PM',
    status: 'Approved',
    pointsAwarded: 35,
    reviewerNotes: 'Good pace. Approved.',
  },
];

export const INITIAL_STAVAN_LIBRARY: StavanItem[] = [
  {
    id: 'STV-01',
    title: 'Adinath Dada Nu Stavan',
    dedicatedBhagwan: 'Bhagwan Adinath',
    alphabetGroup: 'A',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
    youtubeUrl: 'https://www.youtube.com/watch?v=6Yt-R-Bsc7E',
    lyrics: [
      'Adinath prabhu na charano ma, mitha bhav dharu,',
      'Pratham tirthankar parmatma ne, koti vandan karu.',
      'Aatam ma divya jyoti jage, dhyan prabhu nu dharu,',
      'Marudeva mata na nandan ne, premthi sneh dharu.',
    ],
  },
  {
    id: 'STV-02',
    title: 'Bhaktamar Stotra Sanskrit',
    dedicatedBhagwan: 'Bhagwan Adinath',
    alphabetGroup: 'B',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
    youtubeUrl: 'https://www.youtube.com/watch?v=Yf7-y8bNqrs',
    lyrics: [
      'Bhaktamara-Pranata-Mauli-Mani-Prabhaanaam,',
      'Udyotakam Dalit-Paapa-Tamo-Vitaanam.',
      'Samyak-Pranamya Jina-Paada-Yugam Yugaadaav,',
      'Aalambanam Bhava-Bhayaat Pranataam Janaanaam.',
    ],
  },
  {
    id: 'STV-03',
    title: 'Mahavir Swami Nu Stavan',
    dedicatedBhagwan: 'Bhagwan Mahavir',
    alphabetGroup: 'M',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
    youtubeUrl: 'https://www.youtube.com/watch?v=gM_H6_K_1QY',
    lyrics: [
      'Trishla nandan veer ki, jai bolo mahavir ki,',
      'Siddharth na raj dulara, jagat ne mukti apo prabhu pyara.',
      'Sanyam marag swikarine prabhu, kevalgyan pamyaji,',
      'Saman suttam na vachano thi, jivan dhanya thayaji.',
    ],
  },
  {
    id: 'STV-04',
    title: 'Maitri Bhavnu Pavitra Jharnu',
    dedicatedBhagwan: 'Other Tirthankars',
    alphabetGroup: 'M',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3',
    youtubeUrl: '',
    lyrics: [
      'Maitri bhavnu pavitra jharnu, mujh haiyya ma vahya kare,',
      'Shubh thao aa sakal vishwanu, evi bhavna nitya rahe.',
      'Guniyal jono darshan karine, haiyyu maru harshayaji,',
      'Pramod bhavthi hridaya bharay, prem rasbhinu thayaji.',
    ],
  },
];

export const INITIAL_AUDIO_ASSETS: AudioAsset[] = [
  {
    id: 'AUD-101',
    title: 'Navkar Mantra Master Chanting',
    category: 'Sutra',
    levelTarget: 1,
    duration: '01:24',
    fileSize: '1.8 MB',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
  },
  {
    id: 'AUD-102',
    title: 'Bhaktamar Stotra Slow Guide',
    category: 'Stavan',
    levelTarget: 2,
    duration: '14:20',
    fileSize: '16.5 MB',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
  },
  {
    id: 'AUD-103',
    title: 'Paryushan Significance Pravachan by Samanji',
    category: 'Pravachan',
    levelTarget: 3,
    duration: '42:10',
    fileSize: '48.2 MB',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
  },
];

export const INITIAL_GAMES: QuizGameItem[] = [
  {
    id: 'GM-101',
    title: '24 Tirthankaras Symbol Match',
    category: 'Memory Match',
    levelTarget: 1,
    difficulty: 'Easy',
    rewardPoints: 30,
    timesPlayed: 142,
    configJson: '{"type":"memory_match","cards":12}',
  },
  {
    id: 'GM-102',
    title: 'Iryavahiyam Repentance Master Quiz',
    category: 'Quiz',
    levelTarget: 3,
    difficulty: 'Hard',
    rewardPoints: 50,
    timesPlayed: 88,
    configJson: '{"type":"mcq_quiz","questions":10}',
  },
  {
    id: 'GM-103',
    title: 'Jain Virtues Word Search',
    category: 'Word Puzzle',
    levelTarget: 2,
    difficulty: 'Medium',
    rewardPoints: 40,
    timesPlayed: 110,
    configJson: '{"type":"word_search","gridSize":10}',
  },
];

export const INITIAL_NIYAM_SUBMISSIONS: NiyamSubmission[] = [
  {
    id: 'NYM-901',
    studentId: 'STU-101',
    studentName: 'Aarav Shah',
    level: 'Level 3 - Shravak Junior',
    submissionDate: '2026-07-23',
    completedNiyams: ['Navkar Mantra (5 times)', 'Night Pratikraman', 'Temple Visit'],
    pointsEarned: 40,
    status: 'Auto-Approved',
  },
  {
    id: 'NYM-902',
    studentId: 'STU-102',
    studentName: 'Dhairya Kothari',
    level: 'Level 2 - Madhyamik',
    submissionDate: '2026-07-23',
    completedNiyams: ['Navkar Mantra (5 times)', 'Chovihar (No eating after sunset)'],
    pointsEarned: 25,
    status: 'Auto-Approved',
  },
  {
    id: 'NYM-903',
    studentId: 'STU-104',
    studentName: 'Hetvi Desai',
    level: 'Level 3 - Shravak Junior',
    submissionDate: '2026-07-22',
    completedNiyams: ['1-Day Fasting (Upvas) Special Vow'],
    pointsEarned: 100,
    status: 'Pending Guruji',
  },
];

export const INITIAL_NIYAM_RULES: NiyamRule[] = [
  {
    id: 'RUL-01',
    title: 'Navkar Mantra (5 times)',
    level: 'All Levels',
    defaultPoints: 10,
    autoApprove: true,
    description: 'Chant 5 malas or 5 times Navkar Mantra with purity in morning.',
  },
  {
    id: 'RUL-02',
    title: 'Chovihar (No eating after sunset)',
    level: 'All Levels',
    defaultPoints: 15,
    autoApprove: true,
    description: 'Voluntary cessation of food and water after sunset.',
  },
  {
    id: 'RUL-03',
    title: 'Special Fasting / Upvas',
    level: 'Level 2 & Level 3',
    defaultPoints: 100,
    autoApprove: false,
    description: 'Complete 24-hour fast. Requires Guruji verification.',
  },
];

export const INITIAL_BONUS_EVENTS: BonusEventItem[] = [
  {
    id: 'EVT-2026-01',
    title: '⭐ Paryushan Mahaparva Special Activities',
    description: 'Earn double bonus points during the holy 8 days of Paryushan by logging Swadhyay and Pratikraman.',
    pointsValue: 100,
    eventDate: '2026-09-10',
    eligibleLevels: ['Level 1 - Prarambhik', 'Level 2 - Madhyamik', 'Level 3 - Shravak Junior'],
  },
  {
    id: 'EVT-2026-02',
    title: 'Mahavir Jayanti Essay & Speech Competition',
    description: 'Participate in the annual Pathshala elocution contest.',
    pointsValue: 75,
    eventDate: '2026-04-14',
    eligibleLevels: ['Level 2 - Madhyamik', 'Level 3 - Shravak Junior'],
  },
];

export const INITIAL_POINTS_TRANSACTIONS: PointsLedgerTransaction[] = [
  {
    id: 'TXN-801',
    timestamp: '2026-07-22 10:15 AM',
    studentId: 'STU-101',
    studentName: 'Aarav Shah',
    reason: 'Iryavahiyam Sutra 4 Gathas Approved',
    points: 50,
    type: 'Credit',
    adjustedBy: 'Rajvi Ben Shah (Guruji)',
  },
  {
    id: 'TXN-802',
    timestamp: '2026-07-21 04:30 PM',
    studentId: 'STU-102',
    studentName: 'Dhairya Kothari',
    reason: 'Paryushan Swadhyay Bonus Event',
    points: 100,
    type: 'Credit',
    adjustedBy: 'Ketanbhai Mehta (Admin)',
  },
  {
    id: 'TXN-803',
    timestamp: '2026-07-20 02:00 PM',
    studentId: 'STU-104',
    studentName: 'Hetvi Desai',
    reason: 'Correction for unverified Niyam claim',
    points: -15,
    type: 'Debit',
    adjustedBy: 'Admin Office',
  },
];

export const INITIAL_AUDIT_LOGS: AuditLogEntry[] = [
  {
    id: 'LOG-7001',
    timestamp: '2026-07-23 09:20 AM',
    actorName: 'Ketanbhai Mehta',
    actorRole: 'Admin',
    action: 'APPROVED_REGISTRATION',
    module: 'Registration Approvals',
    details: 'Approved registration REG-2026-004 for student Aanya Shah, assigned Level 1.',
    status: 'Success',
  },
  {
    id: 'LOG-7002',
    timestamp: '2026-07-22 05:10 PM',
    actorName: 'Rajvi Ben Shah',
    actorRole: 'Guruji',
    action: 'REVIEWED_GATHA',
    module: 'Sutras & Gathas',
    details: 'Approved 4 Gathas for Aarav Shah (STU-101) and awarded 50 bonus points.',
    status: 'Success',
  },
  {
    id: 'LOG-7003',
    timestamp: '2026-07-22 02:40 PM',
    actorName: 'Ketanbhai Mehta',
    actorRole: 'Admin',
    action: 'SCHEDULED_LIVE_CLASS',
    module: 'Live Classes',
    details: 'Created live class "Sutra Navtatva Chapter 3" for Level 3 on Zoom.',
    status: 'Success',
  },
];

export const INITIAL_BROADCASTS: BroadcastMessage[] = [
  {
    id: 'BRD-301',
    title: 'Special Paryushan Preparation Meeting',
    category: 'Class Announcement',
    targetAudience: 'All Parents & Students',
    dispatchedTime: '2026-07-22 06:00 PM',
    channels: ['In-App', 'WhatsApp'],
    messageBody: 'Jai Jinendra! Please join us this Sunday at 10:00 AM for the Paryushan Preparation Assembly.',
    deliveryStatus: 'Delivered (145/145)',
  },
  {
    id: 'BRD-302',
    title: 'Reminder: Daily Niyam Cutoff at Sunset',
    category: 'Niyam Reminder',
    targetAudience: 'Level 2 & Level 3 Students',
    dispatchedTime: '2026-07-21 05:00 PM',
    channels: ['In-App', 'SMS'],
    messageBody: 'Kindly submit your daily niyam check-in before 07:15 PM today.',
    deliveryStatus: 'Delivered (67/67)',
  },
];

export const INITIAL_QUOTES: DailyQuoteItem[] = [
  {
    id: 'Q-001',
    quote: 'ghjjghkjhkjhkh',
    author: 'ghjhgj',
    language: 'HINDI',
    displayDate: '2026-07-24',
    status: 'PUBLISHED',
    createdBy: 'Aditya Rangi',
    lastUpdated: '2026-07-21',
    hasCustomBg: true,
  },
  {
    id: 'Q-002',
    quote: 'Do not injure, abuse, oppress, enslave, insult, torment, torture, or kill any living creature.',
    author: 'Lord Mahavira',
    language: 'ENGLISH',
    displayDate: '2026-07-21',
    status: 'DRAFT',
    createdBy: 'Aditya Rangi',
    lastUpdated: '2026-07-21',
    hasCustomBg: true,
  },
  {
    id: 'Q-003',
    quote: 'sdfsfsf',
    author: 'dfsdfdd',
    language: 'HINDI',
    displayDate: '2026-07-21',
    status: 'PUBLISHED',
    createdBy: 'Aditya Rangi',
    lastUpdated: '2026-07-21',
    hasCustomBg: true,
  },
];

export const INITIAL_GURUDEV: GurudevProfileItem[] = [
  {
    id: 'GD-001',
    name: 'Acharya Shri Jin Piyushsagar Surishwarji Maharaja',
    title: 'Current Gachhadhipati',
    gachhadhipatiTitle: '79th Gachhadhipati of Khatargachh',
    photoUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=300',
    biography: 'Revered spiritual leader, scholar, and guide of Shri Jain Swetamber Khatargachh Sangh.',
    dikshaDate: '1978-05-12',
    birthPlace: 'Palanpur, Gujarat',
    status: 'PUBLISHED',
  },
];

export const INITIAL_SADHU_SADHVIJI: SadhuSadhvijiItem[] = [
  {
    id: 'SS-001',
    name: 'Muni Shri Prashamratna Vijayji Maharaja',
    category: 'Sadhu',
    currentLocation: 'Palitana Dham, Gujarat',
    dikshaYear: '1996',
    preshitBy: 'Acharya Shri Piyushsagarji',
    status: 'Active',
  },
  {
    id: 'SS-002',
    name: 'Sadhvi Shri Sambodhi Shriji Maharaja',
    category: 'Sadhviji',
    currentLocation: 'Surat Sangh, Gujarat',
    dikshaYear: '2002',
    preshitBy: 'Acharya Shri Piyushsagarji',
    status: 'Vihar In Progress',
  },
];

export const INITIAL_VIHAR_UPDATES: ViharUpdateItem[] = [
  {
    id: 'VU-001',
    monkGroup: 'Muni Shri Prashamratna Vijayji & Samuday',
    fromLocation: 'Ahmedabad Sangh',
    toLocation: 'Palitana Tirth',
    nextStop: 'Limbdi Sangh',
    distanceKm: 18,
    expectedArrival: '2026-07-24 09:00 AM',
    status: 'EN ROUTE',
    updatedAt: '2026-07-23 06:30 AM',
  },
];

export const INITIAL_CHATURMAS: ChaturmasDetailItem[] = [
  {
    id: 'CH-2026',
    year: '2026',
    sanghName: 'Khatargachh Jain Sangh, Borivali West',
    city: 'Mumbai',
    monkName: 'Acharya Shri Jin Piyushsagar Surishwarji Maharaja',
    startDate: '2026-07-29',
    endDate: '2026-11-25',
    status: 'CURRENT',
  },
];

export const INITIAL_BOOKS: BookStoreItem[] = [
  {
    id: 'BK-001',
    title: 'Khatargachh Pattavali & History',
    author: 'Acharya Jin Prabha Suri',
    category: 'History',
    price: 250,
    stock: 45,
    language: 'Hindi',
    status: 'AVAILABLE',
  },
  {
    id: 'BK-002',
    title: 'Navkar Sutra Aradhana',
    author: 'Gurudev Publication',
    category: 'Granth',
    price: 150,
    stock: 120,
    language: 'Gujarati',
    status: 'AVAILABLE',
  },
];

export const DEFAULT_SYSTEM_SETTINGS: SystemSettings = {
  pathshalaName: 'Gyan Vatika Admin Portal',
  academicYear: '2026-2027',
  contactPhone: '+91 22 2800 1234',
  contactEmail: 'admin@epathshala.org',
  dailyNiyamCutoffTime: '19:30',
  autoLogoutTimeoutMinutes: 30,
};

export const initialAdminState = {
  quotes: INITIAL_QUOTES,
  gurudev: INITIAL_GURUDEV,
  sadhuSadhviji: INITIAL_SADHU_SADHVIJI,
  viharUpdates: INITIAL_VIHAR_UPDATES,
  chaturmas: INITIAL_CHATURMAS,
  books: INITIAL_BOOKS,
  adminUsers: INITIAL_ADMIN_USERS,
  students: INITIAL_STUDENTS,
  registrations: INITIAL_PENDING_REGISTRATIONS,
  teachers: INITIAL_TEACHERS,
  academicLevels: INITIAL_LEVELS,
  batches: INITIAL_BATCHES,
  masterEntries: INITIAL_MASTERS,
  liveClasses: INITIAL_SCHEDULED_CLASSES,
  attendanceLogs: INITIAL_ATTENDANCE_LOGS,
  sutras: INITIAL_SUTRAS_CATALOG,
  gathaSubmissions: INITIAL_GATHA_SUBMISSIONS,
  stavans: INITIAL_STAVAN_LIBRARY,
  audioAssets: INITIAL_AUDIO_ASSETS,
  quizGames: INITIAL_GAMES,
  niyamRules: INITIAL_NIYAM_RULES,
  niyamSubmissions: INITIAL_NIYAM_SUBMISSIONS,
  bonusEvents: INITIAL_BONUS_EVENTS,
  pointsTransactions: INITIAL_POINTS_TRANSACTIONS,
  auditLogs: INITIAL_AUDIT_LOGS,
  broadcasts: INITIAL_BROADCASTS,
  settings: DEFAULT_SYSTEM_SETTINGS,
};

